import { apiService } from '../../../shared/services/apiServices';
import clientEndpoints from './clientEndpoints';
import { CLIENT_ERROR_MESSAGES } from '../errors/errorMessages';

export const deleteMediaResource = async (
  path: string
): Promise<{ success: boolean; error?: string }> => {
  try {
    const result = await apiService.deleteAPI(clientEndpoints.MEDIA_RESOURCES, {
      path,
    });

    if (result.error) {
      return { success: false, error: CLIENT_ERROR_MESSAGES.DEFAULT_ERROR };
    }

    return { success: true };
  } catch {
    return { success: false, error: CLIENT_ERROR_MESSAGES.UNEXPECTED_ERROR };
  }
};
